/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesListMCPServersRequest,
  KillswitchesListMCPServersSecurity,
} from "../models/operations/killswitcheslistmcpservers.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildKillswitchMCPServersQuery,
  KillswitchMCPServersQueryData,
  prefetchKillswitchMCPServers,
  queryKeyKillswitchMCPServers,
} from "./killswitchMCPServers.core.js";
export {
  buildKillswitchMCPServersQuery,
  type KillswitchMCPServersQueryData,
  prefetchKillswitchMCPServers,
  queryKeyKillswitchMCPServers,
};

export type KillswitchMCPServersQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listMCPServers killswitches
 */
export function useKillswitchMCPServers(
  security: KillswitchesListMCPServersSecurity,
  request?: KillswitchesListMCPServersRequest | undefined,
  options?: QueryHookOptions<
    KillswitchMCPServersQueryData,
    KillswitchMCPServersQueryError
  >,
): UseQueryResult<
  KillswitchMCPServersQueryData,
  KillswitchMCPServersQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildKillswitchMCPServersQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

/**
 * listMCPServers killswitches
 */
export function useKillswitchMCPServersSuspense(
  security: KillswitchesListMCPServersSecurity,
  request?: KillswitchesListMCPServersRequest | undefined,
  options?: SuspenseQueryHookOptions<
    KillswitchMCPServersQueryData,
    KillswitchMCPServersQueryError
  >,
): UseSuspenseQueryResult<
  KillswitchMCPServersQueryData,
  KillswitchMCPServersQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildKillswitchMCPServersQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

export function setKillswitchMCPServersData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: KillswitchMCPServersQueryData,
): KillswitchMCPServersQueryData | undefined {
  const key = queryKeyKillswitchMCPServers(...queryKeyBase);

  return client.setQueryData<KillswitchMCPServersQueryData>(key, data);
}

export function invalidateKillswitchMCPServers(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "killswitches",
      "listMCPServers",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllKillswitchMCPServers(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "killswitches", "listMCPServers"],
  });
}
